<template>
  <div>
    <MainHeader />
    <slot />
    <MainFooter />
    <UModals />
  </div>
</template>
